import TemplateView from '../TemplateView'
import ScrollUtils from './ScrollUtils'
import $ from 'jquery'
import ScrollToTopButton from '../components/ScrollToTopButton'
import {fixIScrollInnerWheelEvent} from '../atBrowserUtils'

class ScrollableContainer extends TemplateView {
    constructor($el,
                contentComponent,
                {
                    containerClass = '',
                    contentWrapperClass = '',
                    iScrollParams = {},
                    triggerScrollEvent = false,
                    needRefreshOnResize = false,
                    onScrollCb = (scrollPosition, maxScrollY) => {},
                    onScrollToBottom = () => {},
                    maxScrollToBottomOffset = 200,
                    showScrollToTopButton = false,
                    scrollToTopButtonAdditionalClass = '',
                    shouldUpdateOnInit = true,
                    ignoreScrollingPredicate = () => false
                } = {}) {
        super($el)

        this.contentComponent = contentComponent

        this.containerClass = containerClass
        this.contentWrapperClass = contentWrapperClass

        this.params = {
            iScrollParams,
            triggerScrollEvent,
            needRefreshOnResize,
            showScrollToTopButton,
            scrollToTopButtonAdditionalClass,
            shouldUpdateOnInit,
            maxScrollToBottomOffset,
            ignoreScrollingPredicate,
        }

        this.callbacks = {
            onScrollCb,
            onScrollToBottom,
        }
    }

    afterRender() {
        this.$el.on(ScrollUtils.getWheelEventName(), (e) => {
            // disable iscroll if scroll event already used by another component
            // usually predicate is checking classname in event target tree
            if (this.params.ignoreScrollingPredicate(e.originalEvent)) {
                this.innerScroll.disable()
                setTimeout(() => {
                    this.innerScroll.enable()
                }, 0)
            }
        })


        this.innerScroll = ScrollUtils.addVerticalScroll(this.$el, this.params.iScrollParams)
        //prevent parent scrollable containers scroll
        fixIScrollInnerWheelEvent(this.$el)

        if (this.params.showScrollToTopButton) {
            this.scrollToTopButton = new ScrollToTopButton({
                fadingHeight: 250,
                onClickCb: () => {
                    this.scrollToTop(1000)
                    this.scrollToTopButton.fadeOut(1000)
                },
                scrollToTopButtonAdditionalClass: this.params.scrollToTopButtonAdditionalClass,
            }).init(this.find('.scrollToTopButtonPlaceholder'))
        }

        this.contentComponent = this.contentComponent.init(this.getContainer())
        this.registerChildComponents(this.contentComponent)

        this.innerComponentMethods = {
            setState: this.contentComponent.setState,
            update: this.contentComponent.update
        }
        // proxy some method of inner component
        const self = this
        this.contentComponent.setState = function() {
            self.innerComponentMethods.setState.apply(this, arguments)
            self.forceUpdate()
        }
        this.contentComponent.update = function() {
            self.innerComponentMethods.update.apply(this)
            self.forceUpdate()
        }

        if(this.params.triggerScrollEvent) {
            this.innerScroll.on('scrollStart', () => {
                if (this.innerScroll.hasVerticalScroll) {
                    this.contentComponent.getEl().trigger('scroll')
                }
            })

            this.innerScroll.on('scroll', () => {
                this.contentComponent.getEl().trigger('verticalScroll', {
                    y: this.innerScroll.y,
                    maxScrollY: this.innerScroll.maxScrollY
                })
                this.scrollToTopButton.updateVisibility(this.innerScroll.y)
            })
        }

        this.innerScroll.on('scroll', () => {
            this.callbacks.onScrollCb(this.innerScroll.y, this.innerScroll.maxScrollY)
            this._checkIfScrolledToBottom()
        })

        if (this.params.needRefreshOnResize) {
            $(window).resizeThrottle(() => this.forceUpdate(), 100)
        }
    }

    templateHtml() {
        return "" +
               "<div class='scrollableContainer <%=containerClass%>'>" +
               "    <div class='contentWrapper <%=contentWrapperClass%>'></div>" +
               "    <div class='scrollToTopButtonPlaceholder'></div>" +
               "</div>"
    }

    templateModel() {
        return {
            containerClass: this.containerClass,
            contentWrapperClass: this.contentWrapperClass,
        };
    }

    setState(data) {
        this.applyForChildrenComponents(child => child.setState(data))
        this.forceUpdate()
    }

    getContainer() {
        return this.find('.contentWrapper')
    }

    forceUpdate() {
        ScrollUtils.refreshCustomScroll(this.innerScroll)

        if (this.params.showScrollToTopButton)
            this.scrollToTopButton.updateVisibility(this.innerScroll.y)
        this._checkIfScrolledToBottom()
    }

    shouldUpdateOnInit() {
        return this.params.shouldUpdateOnInit;
    }

    scrollToTop(time = 0) {
        ScrollUtils.scrollToTop(this.innerScroll, this.getEl(), time)
    }

    scrollToBottom() {
        ScrollUtils.scrollToBottom(this.innerScroll)
    }

    /**
     * @deprecated Use onScrollToBottom callback instead
     */
    performIfScrollToBottom(callback, verticalGap = 100) {
        ScrollUtils.performIfScrollToBottom(this.innerScroll, verticalGap, () => {
            callback()
        })
    }

    scrollToElementVertical($el, position, timeMs) {
        ScrollUtils.scrollIntoViewVertical(this.innerScroll, $el[0], position, false, timeMs)
    }

    update() {
        this.applyForChildrenComponents(child => child.update())
        this.forceUpdate()
    }

    _checkIfScrolledToBottom() {
        ScrollUtils.performIfScrollToBottom(this.innerScroll, this.params.maxScrollToBottomOffset, this.callbacks.onScrollToBottom)
    }
}

export default ScrollableContainer



// WEBPACK FOOTER //
// ./web/js/util/ScrollableContainer.js